import { StyleCapabilities } from "@/types";

/** The native resolution of every model that takes custom sizes: an output sized from an image
 *  takes the image's shape with this as its longest side, as the backend sizes it. */
export const CUSTOM_SIZE_TARGET = 1024;

/** Whether the model takes any width and height inside its output envelope, not only a preset.
 *  Mirrors `ModelCapabilitiesConfigImage.accepts_custom_size` in the backend. */
export const getAcceptsCustomSize = (
  capabilities: StyleCapabilities | null | undefined,
): boolean => {
  if (!capabilities || capabilities.outputSizesFixed) return false;
  return [
    capabilities.outputMaxAspectRatio,
    capabilities.outputMinEdge,
    capabilities.outputMaxEdge,
    capabilities.outputMinTotalPixels,
    capabilities.outputMaxTotalPixels,
    capabilities.outputDimensionStep,
  ].some((limit) => limit != null);
};
